import React, { useEffect } from 'react';
import { FaGithub, FaExternalLinkAlt, FaTimes } from 'react-icons/fa';

const ProjectModal = ({ project, onClose }) => {
  useEffect(() => {
    if (!project) return undefined;
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [project, onClose]);

  if (!project) return null;

  const { image, title, github, demo, category, details } = project;
  const hasGithub = github && github !== '#';
  const hasDemo = demo && demo !== '#';

  return (
    <div
      className="project-modal__overlay"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={title}
    >
      <div className="project-modal" onClick={(e) => e.stopPropagation()}>
        <button className="project-modal__close" onClick={onClose} aria-label="Close case study">
          <FaTimes />
        </button>

        <div className="project-modal__image">
          <img src={image} alt={title} />
        </div>

        <div className="project-modal__body">
          {category && <span className="project-modal__category">{category}</span>}
          <h3 className="project-modal__title">{title}</h3>

          {details ? (
            <div className="project-modal__sections">
              {details.problem && (
                <div className="project-modal__section">
                  <h4>The problem</h4>
                  <p>{details.problem}</p>
                </div>
              )}
              {details.role && (
                <div className="project-modal__section">
                  <h4>What I built</h4>
                  <p>{details.role}</p>
                </div>
              )}
              {details.outcome && (
                <div className="project-modal__section">
                  <h4>Outcome</h4>
                  <p>{details.outcome}</p>
                </div>
              )}
              {details.stack && details.stack.length > 0 && (
                <div className="project-modal__section">
                  <h4>Tech stack</h4>
                  <div className="project-modal__stack">
                    {details.stack.map((tech) => (
                      <span key={tech} className="project-modal__chip">{tech}</span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ) : (
            <p className="project-modal__muted">
              A hands-on project from my portfolio. Use the links below to explore the code or the live demo.
            </p>
          )}

          <div className="project-modal__cta">
            {hasGithub && (
              <a href={github} target="_blank" rel="noopener noreferrer" className="btn">
                <FaGithub /> View Code
              </a>
            )}
            {hasDemo && (
              <a href={demo} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                <FaExternalLinkAlt /> Live Demo
              </a>
            )}
            {!hasGithub && !hasDemo && (
              <span className="project-modal__muted">Private client project, code under NDA.</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectModal;
